module.exports = __webpack_public_path__ + "static/media/icon_tc_incendio.432c47eb.svg";